// React
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
// Material UI
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import EditIcon from '@mui/icons-material/Create';
//Style
import useStyles from 'components/dialogs/controlTower/ControlTowerDialogs.style';
import theme from 'assets/theme/theme';
//Pcp components
import DialogData from 'components/dialogs/controlTower/DialogData';

const DialogEditPrice = ({ close, open, stock, price, changeAction, beforeData, botData, nowData }) => {

    const [newStock, setNewStock] = useState(stock ? stock : '');
    const [newPrice, setNewPrice] = useState(price ? price : 0);
    const [shipingCost, setShipingCost] = useState(0);

    const [openDialogData, setOpenDialogData] = useState(false);

    const [newData, setNewData] = useState({});

    useEffect(() => {
        open && resetData();
    }, [open]);

    const classes = useStyles(theme);

    const resetData = () => {
        setNewPrice(price);
        setNewStock(stock);
        setShipingCost(0);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            changeAction({
                price: addShippingCost(newPrice, shipingCost),
                stock: newStock,
                status: newPrice === -1 ? 'NV_BELL' : 'SOLD',
                availability: newData.availability ? newData.availability : '',
                img_url: newData.imgUrl ? newData.imgUrl : '',
                marketplace_offers: newData.marketplaceOffers && newData.marketplaceOffers.length > 0 ? newData.marketplaceOffers : null,
                additional_data: newData.additionalData ? newData.additionalData : null
            });
            setNewPrice(addShippingCost(newPrice, shipingCost));
            setShipingCost(0);
            close();
        }
    };

    const addShippingCost = (prix, shipping) => {
        const p = parseFloat(prix);
        const s = parseFloat(shipping);
        if (typeof p === 'number' && typeof s === 'number' && p > 0 && s > 0) {
            return parseFloat((p + s).toFixed(2));
        }
        return parseFloat(p.toFixed(2));
    };

    const renderDialogData = () => <DialogData
        open={openDialogData}
        onClose={(data) => {
            data && setNewData(data);
            setOpenDialogData(false);
        }}
        closeNoSaving={() => setOpenDialogData(false)}
        editMode={true}
        beforeData={beforeData}
        botData={botData}
        newPrice={addShippingCost(newPrice, shipingCost)}
        nowData={nowData} />;

    return (
        <Dialog
            open={open}
            onClose={close}
            disableRestoreFocus={true}
            aria-labelledby='responsive-dialog-title'
        >
            <DialogTitle id='responsive-dialog-title'>{translate.i18n('EDIT_PRICE')}</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <TextField
                    id='price'
                    type='number'
                    value={newPrice}
                    autoFocus={true}
                    label={translate.i18n('PRICE')}
                    onChange={(e) => setNewPrice(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
                <TextField
                    id='shipingCost'
                    type='number'
                    value={shipingCost}
                    label={'Livraison'}
                    className={classes.select}
                    onChange={(e) => setShipingCost(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
                <FormControl className={classes.select}>
                    <InputLabel>
                        {translate.i18n('STOCK')}
                    </InputLabel>
                    <Select
                        id='demo-simple-select-helper'
                        value={newStock}
                        onChange={(e) => setNewStock(e.target.value)}
                        label={translate.i18n('STOCK')}
                    >
                        <MenuItem value={'en stock'}>{translate.i18n('STOCK_IN')}</MenuItem>
                        <MenuItem value={'sup. 48h'}>{translate.i18n('STOCK_SUP_48H')}</MenuItem>
                        <MenuItem value={'rupture'}>{translate.i18n('STOCK_SOLD_OUT')}</MenuItem>
                        <MenuItem value={'no information'}>{translate.i18n('STOCK_NO_INFORMATION')}</MenuItem>
                    </Select>
                </FormControl>
                <div className={classes.footerText}>
                    <div className={classes.otherData}>
                        <p className={classes.otherDataText}>
                            Autres données :
                        </p>
                        <IconButton className={classes.otherDataIcon} onClick={() => setOpenDialogData(true)}>
                            <EditIcon />
                        </IconButton>
                    </div>
                    <p className={classes.infoText}>
                        Si vous n’ouvrez pas la fenêtre d’édition des autres données, l’item sera sauvegardé uniquement avec les champs ci-dessus.
                    </p>
                </div>
            </DialogContent>
            <DialogActions style={{ paddingTop: '0px' }}>
                <IconButton color='primary' onClick={() => {
                    changeAction({
                        price: addShippingCost(newPrice, shipingCost),
                        stock: newStock === 'no information' ? '' : newStock,
                        status: newPrice === -1 ? 'NV_BELL' : 'SOLD',
                        availability: newData.availability ? newData.availability : '',
                        img_url: newData.imgUrl ? newData.imgUrl : '',
                        marketplace_offers: newData.marketplaceOffers && newData.marketplaceOffers.length > 0 ? newData.marketplaceOffers : null,
                        additional_data: newData.additionalData ? newData.additionalData : null
                    });
                    close();
                }}>
                    <DoneIcon />
                </IconButton>
            </DialogActions>
            {renderDialogData()}
        </Dialog>
    );

};

DialogEditPrice.propTypes = {
    close: PropTypes.func,
    open: PropTypes.bool,
    fullScreen: PropTypes.bool,
    stock: PropTypes.string,
    price: PropTypes.number,
    changeAction: PropTypes.func,
    beforeData: PropTypes.object,
    botData: PropTypes.object,
    nowData: PropTypes.object
};

export default DialogEditPrice;
